document.addEventListener('DOMContentLoaded', function () {
    console.log('DOMContentLoaded');
    // Prevent multiple initializations
    if (window.scriptAlreadyLoaded) {
        console.log('Script already loaded, skipping...');
        return;
    }
    window.scriptAlreadyLoaded = true;


    const burgerMenu = document.getElementById('burgerMenu');
    const mobileMenu = document.getElementById('mobileMenu');

    if (burgerMenu && mobileMenu && !window.burgerMenuInitialized) {
        // Funktion zum Schließen des Menüs
        const closeMobileMenu = () => {
            if (mobileMenu.classList.contains('open')) {
                // Start collapse
                mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';

                // force repaint before collapse
                window.requestAnimationFrame(() => {
                    mobileMenu.style.maxHeight = '0px';
                    mobileMenu.classList.remove('open');
                });

                // Nach Animation verstecken
                mobileMenu.addEventListener('transitionend', function hideAfterCollapse(e) {
                    if (e.propertyName === 'max-height') {
                        mobileMenu.classList.add('hidden');
                        mobileMenu.removeEventListener('transitionend', hideAfterCollapse);
                    }
                });
            }
        };

        burgerMenu.addEventListener('click', () => {
            const isOpen = mobileMenu.classList.contains('open');

            if (isOpen) {
                closeMobileMenu();
            } else {
                // Zeige zuerst das Menü, um scrollHeight zu messen
                mobileMenu.classList.remove('hidden');
                mobileMenu.style.maxHeight = '0px'; // Reset falls vorher offen

                // force repaint
                window.requestAnimationFrame(() => {
                    mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
                    mobileMenu.classList.add('open');
                });
            }
        });

        // Event Listener für alle Links im mobilen Menü
        const menuLinks = mobileMenu.querySelectorAll('.menu-inner a');
        menuLinks.forEach(link => {
            link.addEventListener('click', () => {
                closeMobileMenu();
            });
        });

        window.burgerMenuInitialized = true;
    }


    const swiper = new Swiper('.einblickSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 600,

        /*autoplay: {
            delay: 5000,
                disableOnInteraction: true,
        },*/
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            beforeInit: function () {
                // Alle Titel initial ausblenden
                document.querySelectorAll('.slide-title').forEach(title => {
                    gsap.set(title, {opacity: 0, x: 100});
                });
            },

            init: function () {
                // Verzögerte Animation für den ersten Titel
                setTimeout(() => {
                    const firstTitle = document.querySelector('.slide-title[data-slide="0"]');
                    if (firstTitle) {
                        firstTitle.classList.add('active');
                        gsap.to(firstTitle, {
                            opacity: 1,
                            x: 0,
                            duration: 0.8,
                            ease: "power2.out"
                        });
                    }
                }, 100);
            },

            slideChange: function () {
                // Aktuelle Animation stoppen und neue starten
                gsap.killTweensOf('.slide-title');

                // Alle Titel ausblenden
                document.querySelectorAll('.slide-title').forEach(title => {
                    title.classList.remove('active');
                    gsap.to(title, {
                        opacity: 0,
                        x: 100,
                        duration: 0.4,
                        ease: "power2.in"
                    });
                });

                // Aktuellen Titel einblenden
                const activeTitle = document.querySelector(`.slide-title[data-slide="${this.realIndex}"]`);
                if (activeTitle) {
                    activeTitle.classList.add('active');
                    gsap.fromTo(activeTitle,
                        {
                            opacity: 0,
                            x: -100
                        },
                        {
                            opacity: 1,
                            x: 0,
                            duration: 0.8,
                            delay: 0.2,
                            ease: "power2.out"
                        }
                    );
                }
            }
        }
    });

    var grundrisseSwiper = new Swiper(".grundrisseSwiper", {
        slidesPerView: "auto",
        spaceBetween: 30,
        loop: true,
        speed: 600,
        autoplay: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            beforeInit: function () {
                // Alle Titel initial ausblenden
                document.querySelectorAll('.grundrisse-slide-title').forEach(title => {
                    gsap.set(title, {opacity: 0, x: 100});
                });
            },
            init: function () {
                updateCustomPagination(this.realIndex);

                // Verzögerte Animation für den ersten Titel
                setTimeout(() => {
                    const firstTitle = document.querySelector('.grundrisse-slide-title[data-slide="0"]');
                    if (firstTitle) {
                        firstTitle.classList.add('active');
                        gsap.to(firstTitle, {
                            opacity: 1,
                            x: 0,
                            duration: 0.8,
                            ease: "power2.out"
                        });
                    }
                }, 100);
            },
            slideChange: function () {
                updateCustomPagination(this.realIndex);

                // Aktuelle Animation stoppen und neue starten
                gsap.killTweensOf('.grundrisse-slide-title');

                // Alle Titel ausblenden
                document.querySelectorAll('.grundrisse-slide-title').forEach(title => {
                    title.classList.remove('active');
                    gsap.to(title, {
                        opacity: 0,
                        x: -100,
                        duration: 0.4,
                        ease: "power2.in"
                    });
                });

                // Aktuellen Titel einblenden
                const activeTitle = document.querySelector(`.grundrisse-slide-title[data-slide="${this.realIndex}"]`);
                if (activeTitle) {
                    activeTitle.classList.add('active');
                    gsap.fromTo(activeTitle,
                        {
                            opacity: 0,
                            x: 100
                        },
                        {
                            opacity: 1,
                            x: 0,
                            duration: 0.8,
                            delay: 0.2,
                            ease: "power2.out"
                        }
                    );
                }
            },
        },

    });

    // Custom Pagination Funktionalität
    document.querySelectorAll('.pagination-item').forEach(item => {
        item.addEventListener('click', () => {
            const index = parseInt(item.dataset.index);
            grundrisseSwiper.slideTo(index);
        });
    });

    function updateCustomPagination(activeIndex) {
        document.querySelectorAll('.pagination-item').forEach((item, index) => {
            if (index === activeIndex) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    // Alternative: More flexible version with subject and body
    function openEmailClientWithDetails(button) {
        const email = button.getAttribute('data-email');
        const subject = button.getAttribute('data-subject') || '';
        const body = button.getAttribute('data-body') || '';

        console.log('openEmailClientWithDetails');
        console.log(subject);

        if (email) {
            let mailtoLink = email;

            // Add subject and body if provided
            const params = new URLSearchParams();
            if (subject) params.append('subject', subject);
            if (body) params.append('body', body);

            if (params.toString()) {
                // Check if email already has parameters
                const separator = email.includes('?') ? '&' : '?';
                mailtoLink += separator + params.toString().replace(/\+/g, '%20');
            }

            window.location.href = mailtoLink;
        }
    }

    const anfrageButton = document.getElementById('anfrageButton');
    console.log(anfrageButton);
    if (anfrageButton) {
        anfrageButton.addEventListener('click', function () {
            openEmailClientWithDetails(this);
        });
    }
});

// Wait for DOM and GSAP to load
window.addEventListener('load', function () {

    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


    // Check if GSAP and ScrollTrigger are available
    if (typeof gsap === 'undefined') {
        console.error('GSAP library not loaded');
        return;
    }

    if (typeof ScrollTrigger === 'undefined') {
        console.error('ScrollTrigger plugin not loaded');
        return;
    }

    let scrollSmoother = ScrollSmoother.create({
        smooth: 1,
        effects: true,
    });
    // Get elements
    const anfrageButton = document.querySelector('.anfrage-button');
    const headerOverlay = document.querySelector('.header-overlay');

    if (anfrageButton && headerOverlay) {
        anfrageButton.addEventListener('mouseenter', () => {
            // Lighten the overlay (reduce opacity)
            gsap.to(headerOverlay, {opacity: 0.3, duration: 0.4, ease: "power2.out"});
        });
        anfrageButton.addEventListener('mouseleave', () => {
            // Restore original dark overlay
            gsap.to(headerOverlay, {opacity: 0.7, duration: 0.4, ease: "power2.out"});
        });
    }

    gsap.to(".header-overlay", {
        opacity: 0.15, // Lighter overlay on scroll
        ease: "power1.out",
        scrollTrigger: {
            trigger: ".header-section",
            start: "top top",
            end: "bottom top",
            scrub: true
        }
    });

    const projektentwicklungTarget = document.querySelector(".projektentwicklung-wrapper");
    const projektentwicklungObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                gsap.to(entry.target, {
                    delay: "2",
                    scale: "1.1",
                    duration: 2,
                    ease: "power1.out"
                });
                observer.unobserve(entry.target); // optional: animate only once
            }
        });
    }, {threshold: 0.1}); // 10% visible
    projektentwicklungObserver.observe(projektentwicklungTarget);

    // Animation für beide Bilder
    const images = document.querySelectorAll('.animate-image');

    images.forEach((image, index) => {
        gsap.fromTo(image,
            {
                scale: 1.2,
                opacity: 0
            },
            {
                scale: 1,
                opacity: 1,
                duration: 5,
                delay: 0.5 + (index * 0.6),
                ease: "power2.inOut",
                scrollTrigger: {
                    trigger: image,
                    start: "top bottom+=150",
                    end: "top top",
                    scrub: 1.5, // Ermöglicht sanftes Scrollen in beide Richtungen
                    toggleActions: "play reverse play reverse", // Spielt Animation vorwärts und rückwärts ab
                    // markers: true, // Für Debugging
                }
            }
        );
    });

// Fade label text from opacity 0.4 to 1 on hover/focus of corresponding dot
    /*document.querySelectorAll('.connector-dot').forEach(dot => {
        const labelClass = dot.getAttribute('data-label');
        const labelEl = labelClass ? document.querySelector('.' + labelClass) : null;

        const lineClass = dot.getAttribute('data-line');
        const lineEl = labelClass ? document.querySelector('.' + lineClass) : null;

        console.log(lineClass);
        console.log(lineEl);

        dot.addEventListener('mouseenter', () => {
            if (labelEl) labelEl.classList.add('active');
            if (lineEl) lineEl.classList.add('active');
        });
        dot.addEventListener('mouseleave', () => {
            if (labelEl) labelEl.classList.remove('active');
            if (lineEl) lineEl.classList.remove('active');
        });
        dot.addEventListener('focus', () => {
            if (labelEl) labelEl.classList.add('active');
            if (lineEl) lineEl.classList.add('active');
        });
        dot.addEventListener('blur', () => {
            if (labelEl) labelEl.classList.remove('active');
            if (lineEl) lineEl.classList.remove('active');
        });
    });*/


});
(() => {
    class ResponsiveDiagram {
        constructor() {
            this.image = document.getElementById('mainImage');
            this.container = document.getElementById('diagramContainer');
            this.connectors = [];

            // Define connector positions based on the ORIGINAL image dimensions
            this.connectorPositions = [
                {id: 1, x: 0.09, y: 0.05, labelPosition: 'top', textAlign: 'left'},
                {id: 2, x: 0.30, y: 0.295, labelPosition: 'top', textAlign: 'left'},
                {id: 3, x: 0.70, y: 0.38, labelPosition: 'top', textAlign: 'right'},
                {id: 4, x: 0.92, y: 0.40, labelPosition: 'top', textAlign: 'right'},
                {id: 5, x: 0.035, y: 0.28, labelPosition: 'bottom', textAlign: 'left'},
                {id: 6, x: 0.26, y: 0.94, labelPosition: 'bottom', textAlign: 'left'},
                {id: 7, x: 0.60, y: 0.90, labelPosition: 'bottom', textAlign: 'right'},
                {id: 8, x: 0.96, y: 0.45, labelPosition: 'bottom', textAlign: 'right'}
            ];

            // Define fixed label Y positions (in pixels from image top/bottom)
            this.labelYPositions = {
                top: -90,    // 80px above the image
                bottom: 50   // 20px below the image
            };

            this.init();
        }

        init() {
            this.setupConnectors();
            this.bindEvents();

            // Position elements after image loads
            if (this.image.complete) {
                this.positionElements();
            } else {
                this.image.addEventListener('load', () => this.positionElements());
            }

            // Reposition on window resize
            window.addEventListener('resize', this.debounce(() => this.positionElements(), 100));
        }

        setupConnectors() {
            this.connectorPositions.forEach(pos => {
                const dot = document.querySelector(`[data-id="${pos.id}"]`);
                const line = document.querySelector(`[data-line="${pos.id}"]`);
                const label = document.querySelector(`[data-label="${pos.id}"]`);

                if (dot && line && label) {
                    this.connectors.push({
                        id: pos.id,
                        dot,
                        line,
                        label,
                        position: pos
                    });

                    this.bindConnectorEvents(dot, line, label);
                }
            });
        }

        bindConnectorEvents(dot, line, label) {
            // Mouse events
            dot.addEventListener('mouseenter', () => {
                dot.classList.add('active');
                label.classList.add('active');
                line.classList.add('active');
            });

            dot.addEventListener('mouseleave', () => {
                dot.classList.remove('active');
                label.classList.remove('active');
                line.classList.remove('active');
            });

            // Keyboard events
            dot.addEventListener('focus', () => {
                dot.classList.add('active');
                label.classList.add('active');
                line.classList.add('active');
            });

            dot.addEventListener('blur', () => {
                dot.classList.remove('active');
                label.classList.remove('active');
                line.classList.remove('active');
            });

            // Verbesserte Touch-Events für Mobile
            let touchStartTime = 0;

            dot.addEventListener('touchstart', (e) => {
                e.preventDefault();
                touchStartTime = Date.now();
            }, {passive: false});

            dot.addEventListener('touchend', (e) => {
                e.preventDefault();
                const touchDuration = Date.now() - touchStartTime;

                // Nur bei kurzen Touches (Taps) reagieren
                if (touchDuration < 300) {
                    this.toggleConnector(dot, line, label);
                }
            }, {passive: false});

            // Fallback für Click-Event
            dot.addEventListener('click', (e) => {
                if (!this.isTouchDevice()) {
                    e.preventDefault();
                    this.toggleConnector(dot, line, label);
                }
            });

        }

        toggleConnector(dot, line, label) {
            const isActive = label.classList.contains('active');

            // Close all others first
            this.connectors.forEach(conn => {
                conn.dot.classList.remove('active');
                conn.line.classList.remove('active');
                conn.label.classList.remove('active');
            });

            // Toggle current one
            if (!isActive) {
                dot.classList.add('active');
                line.classList.add('active');
                label.classList.add('active');
            }
        }

        positionElements() {
            const imageWidth = this.image.offsetWidth;
            const imageHeight = this.image.offsetHeight;

            this.connectors.forEach(connector => {
                const pos = connector.position;

                // Calculate dot position
                const dotX = imageWidth * pos.x;
                const dotY = imageHeight * pos.y;

                // Position the dot
                connector.dot.style.left = `${dotX}px`;
                connector.dot.style.top = `${dotY}px`;

                // Position the line and label with aligned Y positions
                this.positionLineAndLabel(connector, dotX, dotY, imageWidth, imageHeight);
            });
        }

        positionLineAndLabel(connector, dotX, dotY, imageWidth, imageHeight) {
            const {line, label, position} = connector;
            const labelPos = position.labelPosition;
            const labelTextAlign = position.textAlign;
            const isSmallScreen = window.innerWidth < 500;

            // Calculate fixed label Y position
            const labelY = labelPos === 'top'
                ? this.labelYPositions.top
                : imageHeight + this.labelYPositions.bottom;

            // Calculate label X position with responsive adjustments
            let labelX = dotX;

            // Calculate line positioning
            let lineY, lineHeight;

            if (labelPos === 'top') {
                const lineStartY = labelY + 65;
                const lineEndY = dotY;
                lineY = lineStartY;
                lineHeight = lineEndY - lineStartY;
            } else {
                const lineStartY = dotY;
                const lineEndY = labelY - 5;
                lineY = lineStartY;
                lineHeight = lineEndY - lineStartY;
            }

            // Remove existing animation classes and reset any conflicting styles
            line.classList.remove('line-vertical', 'line-diagonal');
            line.classList.add('line-vertical');

            // Set line properties for vertical lines
            line.style.left = `${dotX}px`;
            line.style.top = `${lineY}px`;
            line.style.height = `${lineHeight}px`;
            line.style.width = '2px';
            line.style.transformOrigin = labelPos === 'top' ? 'bottom' : 'top';

            // Position label with responsive behavior
            label.style.left = `${labelX}px`;
            label.style.top = `${labelY}px`;

            // Handle text alignment and positioning
            if (labelTextAlign === 'right') {
                label.style.textAlign = 'right';

                if (isSmallScreen) {
                    // On small screens, adjust the offset for right-aligned labels
                    label.style.left = `${labelX - 170}px`; // Smaller offset for mobile
                } else {
                    label.style.left = `${labelX - 220}px`; // Original offset for desktop
                }
            } else {
                // For left-aligned labels on small screens
                if (isSmallScreen) {
                    // Ensure left-aligned labels don't go off-screen
                    const minX = 10; // 10px margin from left edge
                    labelX = Math.max(minX, labelX);
                    label.style.left = `${labelX}px`;
                }
            }

            // Additional small screen adjustments if needed
            /*if (isSmallScreen) {
                // You can add more specific adjustments here
                // For example, adjust label width or font size
                label.style.maxWidth = '180px'; // Prevent labels from being too wide
                label.style.fontSize = '0.8rem'; // Slightly smaller text
            } else {
                // Reset styles for larger screens
                label.style.maxWidth = '';
                label.style.fontSize = '';
            }*/
        }

        bindEvents() {
            // Close all labels when clicking outside
            document.addEventListener('click', (e) => {
                if (!e.target.closest('.connector-dot')) {
                    this.connectors.forEach(conn => {
                        conn.dot.classList.remove('active');
                        conn.line.classList.remove('active');
                        conn.label.classList.remove('active');
                    });
                }
            });
        }

        debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
        new ResponsiveDiagram();
    });
})();

